import { AttachmentsDownloadList } from '@/shared/ui/AttachmentsDownloadList';
import { UserAvatar } from '@/shared/ui/UserAvatar';
import { formatDateTimeWithAMPM } from '@/shared/lib/utils/formatLondonDateTime';
import { ILessonNote } from '@/shared/types/lesson';

interface ILessonNoteProps {
  note: ILessonNote;
  userId: number | null;
}

export const LessonNote = ({ note, userId }: ILessonNoteProps) => {
  const { author, message, createdAt, attachments } = note;
  const isStaff = author.role === 'staff';
  const isOwner = author.id === userId;

  return (
    <li
      className={`flex flex-col rounded-[24px] gap-4 p-6 ${isOwner ? 'bg-grey-10' : 'bg-[#91AAFF1A]'}`}
    >
      <div className="flex justify-between items-center gap-4">
        <UserAvatar
          avatar={author.avatar ?? null}
          userName={author.username}
          href={isStaff ? `/staff/${author.id}` : undefined}
        />
        <div>
          <p className="text-grey-secondary font-medium text-sm">
            Sent:
            <span className="ml-1 text-[#211D55] font-bold">
              {formatDateTimeWithAMPM(createdAt)}
            </span>
          </p>
        </div>
      </div>
      <p className="text-black">{message}</p>
      {attachments.length > 0 && <AttachmentsDownloadList attachments={attachments} />}
    </li>
  );
};
